import { useState, useEffect } from "react";
import AxiosInstance from "../Axios";
import 'react-toastify/dist/ReactToastify.css';
import { CButton, CFormSelect, CFormLabel } from "@coreui/react";
import { cilTrash } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import GalleryObjectForm from "./GalleryObjectForm";
import { BsSortNumericDown } from 'react-icons/bs';
import { sortObj } from "../store/sortObj";
import { unique } from "src/REDUX/store";
import BasicModal from "../Modal";

const GalleryObject = ({ dataId, currentGalleries, popup, typeChain = 'objects' }) => {

  const user = localStorage.getItem('user_data');
  const [galleryList, setGalleryList] = useState([])
  const [gallery, setGallery] = useState(false);
  const [galleryObject, setGalleryObject] = useState(currentGalleries);
  const [tempLoad, setTempLoad] = useState(false);

  const [selectedData, setSelectedData] = useState(null); // Вибрана галерея для редагування
  const [showModalItemUpdate, setShowModalItemUpdate] = useState(false); // Показати модальне вікно для оновлення галереї

  // Функція для відкривання модального вікна та оновлення даних
  const actionShowModalItemUpdate = (rez) => {
    setShowModalItemUpdate(rez);
    if (!rez) {
      setSelectedData(rez);
    };
  };

  function showElement(gallery) {
    setSelectedData(gallery);
    setShowModalItemUpdate(true);
  }

  useEffect(() => {
    setTempLoad(true);
    AxiosInstance.get(`/galleries?pagination=false`).then((responce) => {
      if (responce.status == 200) {
        const gallerySelect = responce.data['hydra:member'].map((gallery) => {
          return { label: gallery.name, value: gallery.id, data: gallery }
        })
        setGalleryList(unique([{ label: 'Оберіть галерею', value: false }, ...gallerySelect], 'label'));
      }
    }).finally(()=> {
      setTempLoad(false);
    })
  }, [])

  const postGalleryItem = async (data, parentGalery) => {
    const article = {
      name: data.name,
      content: data.contentUrl,
      gallery: `/api/galleries/${parentGalery}`,
      media: data.media["@id"],
      urlPhoto: data.urlPhoto,
      urlVideo: data.urlVideo
    };
    const galleryItem = await AxiosInstance.post('/gallery_items', article);
    return galleryItem.data;
  }

  function addGallery() {
    if (gallery) {
      const selectGallery = galleryList.find(gall => gall.value == gallery);
      // параметри для створення нової галереї по вибраному шаблону
      const article = {
        name: selectGallery.data.name,
        content: selectGallery.data.content,
        sort: selectGallery.data.sort,
        ...(typeChain === 'objects' && {object: `/api/${typeChain}/${dataId}`}),
        ...(typeChain === 'pages' && {pages: [`/api/${typeChain}/${dataId}`]}),
      }
      AxiosInstance.post('/galleries', article).then(response => {
        // відправка запитів на стоврення нових galleryItem для новоствореної галереї по вибраному шаблону
        const requests = selectGallery.data.galleryItems.map(item => postGalleryItem(item, response.data.id))
        Promise.all(requests).then((respItems) => {
          setGalleryObject([...galleryObject, { ...response.data, galleryItems: respItems }]);
          popup.toastifySuccess('Галерею додано');
        })
      })
    }
  }

  function removeGallery(id) {
    AxiosInstance.delete(`/galleries/${id}`)
    .then(() => {
      const filtredGalleries = galleryObject.filter(gallery => gallery.id !== id);
      setGalleryObject(filtredGalleries);
      popup.toastifySuccess('Галерею видалено');
    })
    .catch(() => {
      popup.toastifyWarning('Помилка видалення галереї');
    });
  }

  return (
    <div className="gallery-object">
      <CFormLabel htmlFor="gallery-select">Шаблони створених галерей</CFormLabel>
      <div className="mb-3 d-flex align-items-center gap-3 info-row">
        <CFormSelect
          aria-label="gallery-object__select"
          onChange={(e) => setGallery(e.target.value)}
          defaultValue={false}
          disabled={tempLoad}
          required
          options={galleryList}
          style={{ maxWidth: '500px', height: '100%' }}
        />
        <button type="button" onClick={addGallery} className="mb-2 mt-2 btn btn-secondary">+</button>
        {/* <button type="button" onClick={createGallery} className="mb-2 mt-2 btn btn-secondary">{!isCreate ? "Створити галерею" : "Повернутись"}</button> */}
      </div>
      {galleryObject?.length > 0 && sortObj(galleryObject, 'sort').map((gallery, index) => {
            const galleryPic = gallery?.galleryItems?.[0]?.media?.resizeImagings?.[0]?.contentUrl;
            return <div key={index} className="mt-4 w-100 d-flex align-items-center justify-content-between">
                     <div onClick={()=> showElement(gallery)} className="models-title d-flex align-items-center gap-3">
                         <small><BsSortNumericDown />{gallery.sort}</small>
                         <span className="models-template-img">
                           <img
                             src={galleryPic ? process.env.REACT_APP_SERVER_URL + galleryPic : '/models-template.svg'}
                             alt='model-template'
                             onError={(e) => { e.target.onerror = null; e.target.src = '/models-template.svg'; }}
                           />
                         </span>
                        <span className="models-title-type">{gallery.name}</span>
                    </div>
                    <div className="models-action d-flex align-items-center gap-1">
                    <CButton color="none" variant="outline" className='models-edit-btn'
                      onClick={()=> showElement(gallery)} 
                      style={{ cursor: "pointer" }} 
                      title="Редагувати"
                    >
                      <img src='/custom-edit.svg' alt='edit-template' /> Редагувати
                    </CButton>
                    <CButton className="ms-2" color="danger" variant="outline" onClick={() => removeGallery(gallery.id)}>
                        <CIcon icon={cilTrash} customClassName="nav-icon" height={20} />
                    </CButton>
                    </div>
                </div>
        })}
      {/* Модальне вікно з вибраною галереєю */}
        <div className="mt-4 models-outer">
          <BasicModal
            show={showModalItemUpdate}
            actionShowModal={actionShowModalItemUpdate}
            title={selectedData ? "Редагувати галерею" : "Створити галерею"}
            className={"models-popup"}
            btn_name={<>+ Створити галерею</>}
            content={
              <GalleryObjectForm
                user={user}
                data={selectedData}
                setData={setSelectedData}
                actionShowModal={actionShowModalItemUpdate}
                parentId={dataId}
                popup={popup}
                setGalleryObject={setGalleryObject}
                galleryObject={galleryObject}
                typeChain={typeChain}
              />
            }
          />
        </div>
    </div>
  );
};

export default GalleryObject;